/**
 * Shared carousel arrow navigation.
 * Finds [data-carousel-prev] and [data-carousel-next] buttons inside any
 * wrapper that also contains a horizontally-scrolling grid, and scrolls
 * the grid by one card width on click. Disables arrows at scroll boundaries.
 */
(function () {
  'use strict';

  function getGrid(btn) {
    var wrapper = btn.parentElement;
    if (!wrapper) return null;
    return wrapper.querySelector('[class*="__grid"], [class*="__products-grid"]');
  }

  function updateArrows(wrapper) {
    var grid = wrapper.querySelector('[class*="__grid"], [class*="__products-grid"]');
    if (!grid) return;

    var prev = wrapper.querySelector('[data-carousel-prev]');
    var next = wrapper.querySelector('[data-carousel-next]');
    var scrollLeft = Math.round(grid.scrollLeft);
    var maxScroll = grid.scrollWidth - grid.clientWidth;
    var hasOverflow = maxScroll > 1;

    if (prev) {
      prev.hidden = !hasOverflow;
      prev.disabled = scrollLeft <= 1;
    }
    if (next) {
      next.hidden = !hasOverflow;
      next.disabled = scrollLeft >= maxScroll - 1;
    }
  }

  function initWrapper(wrapper) {
    var grid = wrapper.querySelector('[class*="__grid"], [class*="__products-grid"]');
    if (!grid) return;

    updateArrows(wrapper);

    /*
     * Scroll can fire many times per frame during a swipe/smooth scroll.
     * Arrow state needs to update visually, but not dozens of times between
     * paints. Batch scroll + ResizeObserver work into a single animation
     * frame to reduce repeated scrollWidth/clientWidth reads and DOM writes.
     */
    var updateQueued = false;

    function queueArrowUpdate() {
      if (updateQueued) return;
      updateQueued = true;

      requestAnimationFrame(function () {
        updateQueued = false;
        updateArrows(wrapper);
      });
    }

    grid.addEventListener('scroll', queueArrowUpdate, { passive: true });

    if ('ResizeObserver' in window) {
      var observer = new ResizeObserver(queueArrowUpdate);
      observer.observe(grid);
    }
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-carousel-prev], [data-carousel-next]');
    if (!btn) return;

    var grid = getGrid(btn);
    if (!grid) return;

    var card = grid.firstElementChild;
    var gap = parseFloat(getComputedStyle(grid).gap) || 8;
    var step = card ? card.offsetWidth + gap : 300;
    var direction = btn.hasAttribute('data-carousel-next') ? 1 : -1;

    grid.scrollBy({ left: direction * step, behavior: 'smooth' });
  });

  function initWithinScope(scope) {
    var root = scope || document;
    root.querySelectorAll('[data-carousel-prev], [data-carousel-next]').forEach(function (btn) {
      var wrapper = btn.parentElement;
      if (wrapper && !wrapper._arrowsInitialized) {
        wrapper._arrowsInitialized = true;
        initWrapper(wrapper);
      }
    });
  }

  // Public: re-run init within a given DOM scope. Sections that AJAX-replace
  // their grid (e.g. product recommendations) must call this after replacement
  // so disable-at-edges binds to the fresh grid.
  window.odditInitCarouselArrows = initWithinScope;

  initWithinScope(document);

  document.addEventListener('shopify:section:load', function (e) {
    initWithinScope(e.target);
  });
})();
